import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { responseInterceptor } from '../adapters/interceptors';

type SigninRequest = {
  username: string;
  password: string;
};

type SigninResponseSuccess = {
  accessToken: string;
  tokenType: string;
  refreshToken: string;
  expiresIn: number;
};

type SigninResponseError = {
  error: string;
};

const signin =
  (instance: AxiosInstance) =>
  ({
    username,
    password,
  }: SigninRequest): Promise<AxiosResponse<SigninResponseSuccess | SigninResponseError>> =>
    instance.post('/affiliates/tokens', {
      username,
      password,
      grant_type: 'password',
    });

type PasswordResetRequest = {
  email: string;
};

const recoveryPasswordReset =
  (instance: AxiosInstance) =>
  ({ email }: PasswordResetRequest): Promise<AxiosResponse> =>
    instance.post(
      '/affiliates/password-resets',
      {
        email,
      },
      {
        headers: {
          'Accept-Version': 'v1',
        },
      },
    );

type NewPasswordResetRequest = {
  token: string;
  password: string;
};

const newPasswordReset =
  (instance: AxiosInstance) =>
  ({ token, password }: NewPasswordResetRequest): Promise<AxiosResponse> =>
    instance.put(
      `/affiliates/password-resets/${token}`,
      {
        new_password: password,
      },
      {
        headers: {
          'Accept-Version': 'v1',
        },
      },
    );

const auth = () => {
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_AUTH_API}/api`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  instance.interceptors.response.use(responseInterceptor);

  return {
    signin: signin(instance),
    recoveryPasswordReset: recoveryPasswordReset(instance),
    newPasswordReset: newPasswordReset(instance),
  };
};

export { auth };
export type {
  SigninRequest,
  SigninResponseError,
  SigninResponseSuccess,
  PasswordResetRequest,
  NewPasswordResetRequest,
};
